// FIREBASE README
//
// On this project we use Firebase for:
// - Analytics
// - Notifications
//
// Everything is accessed through the consoles - and we have specific projects for each environment
//
// We have two environments:
// - Staging (console -> https://console.firebase.google.com/u/0/project/racing-tv-testing)
// - Production  (console -> https://console.firebase.google.com/u/0/project/racing-uk)

// Each is linked to a specific Google Analytics account:
//  - Staging (GA4 -> https://analytics.google.com/analytics/web/#/p395308555/reports/intelligenthome)
//  - Production (GA4 -> https://analytics.google.com/analytics/web/#/p153118837/reports/intelligenthome)

// Importantly - some firebase features are only available on a development build (i.e non simulator)
// To get those running, its best just to do all firebase changes/debugging on a fresh dev build, e.g:
//  - eas build --profile development (takes ~7 minutss)
//    yarn start --dev-client
//
// Then at this point you can add extra logging, or use the firebase debugger to see what's going on

// in App.tsx, high up:
//    globalThis.RNFBDebug = true;
//
//
// There is an annoying warning in our version(s) of firebase that we can't get rid of on dev builds. It suggests :
//
// Usage of "messaging().registerDeviceForRemoteMessages()" is not required. You only need to register if auto-registration is disabled in your
// 'firebase.json' configuration file via the 'messaging_ios_auto_register_for_remote_messages' property.
//
// if we remove registerDeviceForRemoteMessage it, the next opposite error appears:
//  [Error: [messaging/unregistered] You must be registered for remote messages before calling getToken, see messaging().registerDeviceForRemoteMessages().]
//
// It can be ignored. It's a bug in the firebase library that we can't fix. It's not a problem in production builds.

// firebaseConfig.ts

// ─── 1) Full configs for each environment ────────────────────────────────────────
const STAGING = {
  FIREBASE_VAPID_KEY:
    "BAc66VJ69kUm6XLMo2UGJwC4VjM2IcIheirtEC_nNNaFD03TY-TvoiwEjoYDJLP5UzxFxLSm5H9RQV3-nB3DzeQ",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyC0FgH9_tRVyE3aQIZpk0xFTE_WfPrnJc0",
    authDomain: "racing-tv-testing.firebaseapp.com",
    projectId: "racing-tv-testing",
    storageBucket: "racing-tv-testing.firebasestorage.app",
    messagingSenderId: "50219713312",
    appId: "1:50219713312:web:74c0354d5053e85f098d45",
    measurementId: "G-34H0ZRDMB5",
  },
};

const PRODUCTION = {
  FIREBASE_VAPID_KEY:
    "BKurwrIXigxd5A9qCAusxQ6rFbU5pYkP5t626iRYy2HOqnquKrtLwqjjm6mKBzJOB6fuUbQPG8phK1bF3F0KqO8",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyB3yvc6pfd0VqHJlJvuK7-q3YwEdqAUFYg",
    authDomain: "racing-uk.firebaseapp.com",
    databaseURL: "https://racing-uk.firebaseio.com",
    projectId: "racing-uk",
    storageBucket: "racing-uk.appspot.com",
    messagingSenderId: "272531473920",
    appId: "1:272531473920:web:2ea835186cdf6fe720bae5",
    measurementId: "G-6JRYSW472J",
  },
};

const ENV = process.env.API_ENV === "production" ? "production" : "staging";
const CONFIG = ENV === "production" ? PRODUCTION : STAGING;

console.log(`[Firebase] Using ${ENV} config: `, CONFIG);
// VAPID KEY is used for Web Push
export const FIREBASE_VAPID_KEY = CONFIG.FIREBASE_VAPID_KEY;
export const FIREBASE_CONFIG = CONFIG.FIREBASE_CONFIG;
